// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 869) return "static/chunks/869-865540b5d513fa29.js";
	if (chunkId === 872) return "static/chunks/872-06def790704eef60.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"146":"datadog_browser_logs","340":"layout__client_site_chrome_ui","367":"layout__minimal","748":"datadog_browser_rum"}[chunkId] || chunkId) + "." + {"146":"853cb9b5be66bb17","205":"4cc40c0e1f4cb0f2","319":"0cbc2894a3f1b950","340":"dce4956f4136ca58","367":"f702b78fe324b089","639":"e7b660adfa99260e","748":"c8333e861b5ac213"}[chunkId] + ".js";
};